import { useTranslation } from 'react-i18next'
import { LayoutGrid, List } from 'lucide-react'

interface ViewToggleProps {
  view: 'table' | 'grid'
  onViewChange: (view: 'table' | 'grid') => void
}

export default function ViewToggle({ view, onViewChange }: ViewToggleProps) {
  const { t } = useTranslation()

  return (
    <div className="flex gap-1  rounded p-1">
      <button
        className={`btn btn-sm ${view === 'table' ? 'btn-primary  btn-soft' : 'btn-ghost'}`}
        onClick={() => onViewChange('table')}
        title={t('fileExplorer.viewToggle.tableView')}
        data-testid="view-table"
      >
        <List className="w-4 h-4" />
      </button>
      <button
        className={`btn btn-sm ${view === 'grid' ? 'btn-primary  btn-soft' : 'btn-ghost'}`}
        onClick={() => onViewChange('grid')}
        title={t('fileExplorer.viewToggle.gridView')}
        data-testid="view-grid"
      >
        <LayoutGrid className="w-4 h-4" />
      </button>
    </div>
  )
}
